export default "__VITE_ASSET__Nle54jyy__"